import ScopeEmissionForm from "./ScopeEmissionForm";

const Scope3Form = ({ disabled }) => (
  <ScopeEmissionForm
    scopeKey="scope3"
    label="Scope 3 Emissions"
    disabled={disabled}
  />
);

export default Scope3Form;
